export default [{ Id: 0, Value: '0', Text: 'Full Access' },
{ Id: 1, Value: '1', Text: 'Organization Access' },
{ Id: 2, Value: '2', Text: 'District Access' },
{ Id: 3, Value: '3', Text: 'School Access' },
{ Id: 4, Value: '4', Text: 'Cluster Access' },
{ Id: 99, Value: '99', Text: "User & Associated User Access" },
{ Id: 100, Value: '100', Text: 'User Only Access' }]